import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import QueuesManager from './QueuesManager';

type QueuesDialogProps = {
  open: boolean;
  onClose: () => void;
};

const QueuesDialog: FC<QueuesDialogProps> = (props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth='md'>
      <DialogTitle>Queues</DialogTitle>
      <DialogContent>
        <QueuesManager />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QueuesDialog;
